<div class="auth-page">
  <app-card>
    <app-page-header title="Reset Password" subtitle="Recover access to your account" />
    <p class="auth-placeholder">TODO: Implement reset password flow.</p>
  </app-card>
</div>
